import React, { useContext } from 'react';
import { shallowEqual, useSelector } from 'umi';
import { FilterContext } from "@/pages/dashboard/components/PageContainer/context";
import useEventData from '@/pages/dashboard/servicesModels/overview/overviewEventDataModel';
import type { IOverviewEventDataOptions } from '@/pages/dashboard/servicesModels/overview/overviewEventDataModel';

export interface IEventServiceProps {
  /** 请求地址，缺省为 event 服务中的 date_event_list */
  api?: string;
  /**
   * 传入 useEventData：对 trend 按日列表做连续日同名事件合并。
   * 仅 KPI 总览等需在 pageConfig 中显式开启，默认 false。
   */
  mergeConsecutiveTrendDays?: boolean;
  /** 按 event_type 排除（字符串或与对象 name_cn/name_en/name 任一 trim 后全等），传入 useEventData */
  excludeEventTypes?: string[];
  /** 为 true 时解除事件条数限制与去重参数（传入 useEventData） */
  removeEventNumLimit?: boolean;
  /** 有值时传入 filter_event_date_field（如 KPI 总览用 start_time） */
  filterEventDateField?: string;
  /**
   * 日粒度短区间拉满的最小天数（如 ROAS 趋势需 30 天）。
   * 使事件时间范围与趋势图 minTrendRangeDays 对齐。
   */
  minTrendRangeDays?: number;
  style?: React.CSSProperties;
  className?: string;
  type?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
}

// 事件详情Service层（支持 pageConfig props.api）
export default function EventService(props: IEventServiceProps) {
  const {
    style,
    className,
    type,
    children,
    api,
    mergeConsecutiveTrendDays,
    excludeEventTypes,
    removeEventNumLimit,
    filterEventDateField,
    minTrendRangeDays,
    ...resetProps
  } = props || {};
  const contextObj = useContext(FilterContext);
  const { filterVal, filterLoading } = contextObj || {};

  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    };
  }, shallowEqual);

  const { diff, timeType = 'Day', ...filters } = filterVal;
  const newFormValue = {
    diff,
    timeType,
    filterValue: {
      ...filters
    }
  };

  let eventDataOptions: IOverviewEventDataOptions | undefined;
  if (
    mergeConsecutiveTrendDays ||
    excludeEventTypes?.length ||
    removeEventNumLimit ||
    filterEventDateField ||
    typeof minTrendRangeDays === 'number'
  ) {
    eventDataOptions = {
      ...(mergeConsecutiveTrendDays ? { mergeConsecutiveTrendDays: true } : {}),
      ...(excludeEventTypes?.length ? { excludeEventTypes } : {}),
      ...(removeEventNumLimit ? { removeEventNumLimit: true } : {}),
      ...(filterEventDateField ? { filterEventDateField } : {}),
      ...(typeof minTrendRangeDays === 'number' ? { minTrendRangeDays } : {}),
    };
  }

  const [eventData, loading] = useEventData(
    gameCode,
    newFormValue,
    filterLoading,
    api,
    eventDataOptions,
  );

  return (
    <div className={className} style={style}>
      {
        React.Children.map(children, (child: any) => {
          return React.cloneElement(
            child,
            {
              ...resetProps,
              eventData,
              loading,
              state: {}
            }
          );
        })
      }
    </div>
  );
}
